import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function EcommerceManagement() {
  const { user } = useUser()
  let view = contentLayout[modules.EcommerceManagement]
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.EcommerceManagement.toLowerCase())) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.EcommerceManagement}></Index>
  )
}

export default EcommerceManagement

